import { Navigate, useLocation, useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { legacyHorizonTarget } from "@/data/peptideHorizon";

export default function LegacyHorizonRedirect() {
  const { search, hash } = useLocation();
  const { area } = useParams();
  const target = legacyHorizonTarget(search, area) + hash;
  return <>
    <Helmet>
      <title>Peptide Horizon | PeptideX</title>
      <link rel="canonical" href="https://peptidex.ai/peptide-horizon" />
      <meta name="robots" content="noindex" />
    </Helmet>
    <main className="pt-24 container"><a href={target}>Continue to Peptide Horizon</a></main>
    {typeof window !== "undefined" && <Navigate to={target} replace />}
  </>;
}